import { param } from 'jquery'
import axios from './axios-auth'

/*
    Call the Create New Customer With Payment Intent API. WIll return a client secret that the
    user can use to setup payment details securely
    @param {Object} payload - the payload to send to the api
    @param {Number} clientID - The clientID in our db to setup with Stripe. Required
    @param {String} name - The name of the client. Will be the name of the customer in Stripe
    @param {String} email - The email of the client.
    @param {String} description - the description of the client 
 */
const CreateNewCustomerWithPaymentIntent = async (payload) => {
    try {
        const resp = await axios.post("/hr-adm/setupfunding", payload)
        return resp.data
    }
    catch (e) {
        console.error(e)
        return e
    }


}

const ChargeAndAllocate = async (payload) => {
    try {
        const resp = await axios.post("/hr-adm/chargecustomerallocatepoints", payload)
        return resp
    }
    catch (e) {
        console.error(e)
        return e
    }
}

const GetBalance = async (payload) => {
    try {
        const resp = await axios.post("/hr-adm/balance", payload)
        return resp
    }
    catch (e) {
        console.error(e)
        return e
    }
}

const GetPaymentMethods = async (childClientID) => {
    try {
        const resp = await axios.get("/hr-adm/payment-methods", {params: {clientID: childClientID}})
        return resp
    }
    catch (e) {
        console.error(e)
        return e
    }
}

const SetDefaultPaymentMethod = async (payload) => {
    console.log(payload)
    try {
        const resp = await axios.put("/hr-adm/default-payment-method", payload)
        return resp
    }
    catch (e) {
        console.error(e)
        return e
    }
}

export { CreateNewCustomerWithPaymentIntent, ChargeAndAllocate, GetBalance, GetPaymentMethods, SetDefaultPaymentMethod }